'use strict';

const dateIntervalToTimestampInterval = ({
  start,
  end
}) => {
  return { start: start.getTime(), end: end.getTime() };
};

module.exports = dateIntervalToTimestampInterval;
//# sourceMappingURL=dateIntervalToTimestampInterval.cjs.map
